<template>
    <div class="card--item">

        <router-link :to="'/catalog/product/' + item.slug">
            <div class="image-container">
                <img v-if="item.discount_flag != null && item.discount_flag != 0" src="/img/logo_skidka2.ico" class="discount-img">
                <img :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + '-f64'" :alt="'Вы можете взять в аренду ' + item.name + ' на сервисе фотопроката MRental'">
            </div>
            <div class="h5 text-center mb-12">{{item.name}}</div>
        </router-link>

        <div>
<!--            <router-link to="/">-->
                <!--<h6 class="price-box" v-if="store.common_price.discount && item.not_apply_discount == 0">
                    <span class="mb-0">{{Math.round(item.day_price * (100 - store.common_price.discount) / 100)}} RUB/сутки111</span>
                </h6>-->
                <div class="h6 price-box" v-if="item.discount_flag == null || item.discount_flag == 0">
                    <span>{{item.day_price}} RUB/сутки</span>
                </div>
                <div class="h6 price-box" v-else>
                    <span class="old-price">{{item.discount_old_price}} RUB/сутки</span>
                </div>
<!--            </router-link>-->
            <div class="text-center">
                <div v-if="itemFromBasket">
                    <router-link to="/basket" v-slot="{ navigate }">
                        <button href="/basket" class="button btn-small btn-v2"
                                @click="navigate" role="link">Товар в корзине</button>
                    </router-link>
                </div>

                <div v-else>
                    <button class="button btn-small Vkorziny" v-if="additional" @click="addBasketNoModal()">В корзину</button>
                    <button class="button btn-small Vkorziny" v-else :id="'button_' + item.slug" @click="addBasket()">В корзину</button>
                </div>

            </div>
        </div>


    </div>
</template>

<script>
    import store from '../../../services/data';

    export default {
        props: ['item', 'additional'],
        data() {
            return {
                store: store,
                itemFromBasket: false,
            }
        },
        mounted() {
            this.itemFromBasket = this.store.checkItemBasket(this.item.code)
        },

        methods: {
            addBasket() {
                let data = {
                    code: this.item.code,
                    // slug: this.item.slug,
                    // name: this.item.name,
                    // main_image: this.item.main_image,
                    // day_price: this.item.day_price,
                    // threeHoure_price: this.item.threeHoure_price,
                    count: 1,
                };
                this.store.addToBasket(data);
                if (this.item.accessories && this.$route.name !== 'pages-catalog-show') this.store.state.basket_accessories = this.item.accessories;
                else this.store.state.basket_accessories = null;

                this.store.state.basket_name = this.item.name;
                this.itemFromBasket = this.store.checkItemBasket(this.item.code);

                // this.$root.$emit('bv::show::modal', 'addBasketModal', '#button_' + this.item.slug);
            },

            addBasketNoModal() {
                let data = {
                    code: this.item.code,
                    // slug: this.item.slug,
                    // name: this.item.name,
                    // main_image: this.item.main_image,
                    // day_price: this.item.day_price,
                    // threeHoure_price: this.item.threeHoure_price,
                    count: 1,
                };
                this.store.addToBasket(data);
                this.itemFromBasket = this.store.checkItemBasket(this.item.code);
            }
        }
    }
</script>
